import {FilterCollectionStore, RemoteCollectionStore, SortCollectionStore, StoreBuilder} from '@softline/core';
import {ArtikelvorratKopf} from '../data/artikelvorrat-kopf';

export const ArtikelvorratOffeneKoepfeStore = new StoreBuilder(RemoteCollectionStore.create<ArtikelvorratKopf>())
  .add(FilterCollectionStore.create<ArtikelvorratKopf>())
  .add(SortCollectionStore.create<ArtikelvorratKopf>())
  .value;
